module.exports = __webpack_public_path__ + "static/media/Apple iPad Mini Silver.7ae24ac3.png";